import { render, staticRenderFns } from "./insurance_companies.vue?vue&type=template&id=3f2cd8d7&"
import script from "./insurance_companies.vue?vue&type=script&lang=js&"
export * from "./insurance_companies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports